import { render, staticRenderFns } from "./QuizStudentDaily.vue?vue&type=template&id=aeef8a78&"
import script from "./QuizStudentDaily.vue?vue&type=script&lang=js&"
export * from "./QuizStudentDaily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports